import { render, staticRenderFns } from "./ListAppBar.vue?vue&type=template&id=5d820692&scoped=true"
import script from "./ListAppBar.vue?vue&type=script&lang=js"
export * from "./ListAppBar.vue?vue&type=script&lang=js"
import style0 from "./ListAppBar.vue?vue&type=style&index=0&id=5d820692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d820692",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutMenuCertificados: require('/home/runner/work/loja/loja/components/Layout/MenuCertificados.vue').default,LayoutMenuParcerias: require('/home/runner/work/loja/loja/components/Layout/MenuParcerias.vue').default})
